import React from 'react';
import { List, Datagrid, TextField, DateField, NumberField, ReferenceField } from 'react-admin';

export const ServiceList = () => (
  <List>
    <Datagrid rowClick={false}>
      <TextField source="id" />
      <TextField source="templateName" />
      <ReferenceField source="workshopId" reference="workshops" link={false}>
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="estimatedMinutes" />
      <NumberField source="estimatedRepairPrice" />
      <DateField source="createdAt" />
    </Datagrid>
  </List>
);
